export interface USStateOption {
  value: string;
  label: string;
  name: string;
}

export const US_STATES: USStateOption[] = [
  { value: "AL", name: "Alabama", label: "AL — Alabama" },
  { value: "AK", name: "Alaska", label: "AK — Alaska" },
  { value: "AZ", name: "Arizona", label: "AZ — Arizona" },
  { value: "AR", name: "Arkansas", label: "AR — Arkansas" },
  { value: "CA", name: "California", label: "CA — California" },
  { value: "CO", name: "Colorado", label: "CO — Colorado" },
  { value: "CT", name: "Connecticut", label: "CT — Connecticut" },
  { value: "DE", name: "Delaware", label: "DE — Delaware" },
  { value: "DC", name: "District of Columbia", label: "DC — District of Columbia" },
  { value: "FL", name: "Florida", label: "FL — Florida" },
  { value: "GA", name: "Georgia", label: "GA — Georgia" },
  { value: "HI", name: "Hawaii", label: "HI — Hawaii" },
  { value: "ID", name: "Idaho", label: "ID — Idaho" },
  { value: "IL", name: "Illinois", label: "IL — Illinois" },
  { value: "IN", name: "Indiana", label: "IN — Indiana" },
  { value: "IA", name: "Iowa", label: "IA — Iowa" },
  { value: "KS", name: "Kansas", label: "KS — Kansas" },
  { value: "KY", name: "Kentucky", label: "KY — Kentucky" },
  { value: "LA", name: "Louisiana", label: "LA — Louisiana" },
  { value: "ME", name: "Maine", label: "ME — Maine" },
  { value: "MD", name: "Maryland", label: "MD — Maryland" },
  { value: "MA", name: "Massachusetts", label: "MA — Massachusetts" },
  { value: "MI", name: "Michigan", label: "MI — Michigan" },
  { value: "MN", name: "Minnesota", label: "MN — Minnesota" },
  { value: "MS", name: "Mississippi", label: "MS — Mississippi" },
  { value: "MO", name: "Missouri", label: "MO — Missouri" },
  { value: "MT", name: "Montana", label: "MT — Montana" },
  { value: "NE", name: "Nebraska", label: "NE — Nebraska" },
  { value: "NV", name: "Nevada", label: "NV — Nevada" },
  { value: "NH", name: "New Hampshire", label: "NH — New Hampshire" },
  { value: "NJ", name: "New Jersey", label: "NJ — New Jersey" },
  { value: "NM", name: "New Mexico", label: "NM — New Mexico" },
  { value: "NY", name: "New York", label: "NY — New York" },
  { value: "NC", name: "North Carolina", label: "NC — North Carolina" },
  { value: "ND", name: "North Dakota", label: "ND — North Dakota" },
  { value: "OH", name: "Ohio", label: "OH — Ohio" },
  { value: "OK", name: "Oklahoma", label: "OK — Oklahoma" },
  { value: "OR", name: "Oregon", label: "OR — Oregon" },
  { value: "PA", name: "Pennsylvania", label: "PA — Pennsylvania" },
  { value: "RI", name: "Rhode Island", label: "RI — Rhode Island" },
  { value: "SC", name: "South Carolina", label: "SC — South Carolina" },
  { value: "SD", name: "South Dakota", label: "SD — South Dakota" },
  { value: "TN", name: "Tennessee", label: "TN — Tennessee" },
  { value: "TX", name: "Texas", label: "TX — Texas" },
  { value: "UT", name: "Utah", label: "UT — Utah" },
  { value: "VT", name: "Vermont", label: "VT — Vermont" },
  { value: "VA", name: "Virginia", label: "VA — Virginia" },
  { value: "WA", name: "Washington", label: "WA — Washington" },
  { value: "WV", name: "West Virginia", label: "WV — West Virginia" },
  { value: "WI", name: "Wisconsin", label: "WI — Wisconsin" },
  { value: "WY", name: "Wyoming", label: "WY — Wyoming" },
];

export const US_STATE_CODES: string[] = US_STATES.map((s) => s.value);
export const US_STATE_OPTIONS = US_STATES.map((s) => ({ value: s.value, label: s.label }));

export const CA_PROVINCES: USStateOption[] = [
  { value: "AB", name: "Alberta", label: "AB — Alberta" },
  { value: "BC", name: "British Columbia", label: "BC — British Columbia" },
  { value: "MB", name: "Manitoba", label: "MB — Manitoba" },
  { value: "NB", name: "New Brunswick", label: "NB — New Brunswick" },
  { value: "NL", name: "Newfoundland and Labrador", label: "NL — Newfoundland and Labrador" },
  { value: "NS", name: "Nova Scotia", label: "NS — Nova Scotia" },
  { value: "NT", name: "Northwest Territories", label: "NT — Northwest Territories" },
  { value: "NU", name: "Nunavut", label: "NU — Nunavut" },
  { value: "ON", name: "Ontario", label: "ON — Ontario" },
  { value: "PE", name: "Prince Edward Island", label: "PE — Prince Edward Island" },
  { value: "QC", name: "Quebec", label: "QC — Quebec" },
  { value: "SK", name: "Saskatchewan", label: "SK — Saskatchewan" },
  { value: "YT", name: "Yukon", label: "YT — Yukon" },
];

export const CA_PROVINCE_CODES: string[] = CA_PROVINCES.map((s) => s.value);
export const CA_PROVINCE_OPTIONS = CA_PROVINCES.map((s) => ({ value: s.value, label: s.label }));

export function isUSStateCode(value: string | null | undefined): boolean {
  if (!value) return false;
  return US_STATE_CODES.includes(String(value).toUpperCase());
}

export function normalizeUSState(value: string | null | undefined): string {
  if (!value) return "";
  const v = String(value).trim();
  if (US_STATE_CODES.includes(v.toUpperCase())) return v.toUpperCase();
  const match = US_STATES.find((s) => s.name.toLowerCase() === v.toLowerCase());
  return match?.value ?? v;
}
